import type { ReactElement, ReactNode } from 'react'
import { cn } from 'app/lib/utils'

/** A built-in list's icon on a brand tile, so Trackable's own lists stand apart from the practice's. */
export function BuiltInListMark({ children, className }: { children: ReactNode; className?: string }): ReactElement {
  return (
    <span
      role="img"
      aria-label="Smart list"
      className={cn(
        `flex size-5 shrink-0 items-center justify-center rounded-md bg-primary-500 text-on-color [&_svg]:size-3`,
        className,
      )}
    >
      {children}
    </span>
  )
}
